export default __webpack_public_path__ + "static/media/service.9cdc53a8.png";